import { render, staticRenderFns } from "./ItsBaseCustomer.vue?vue&type=template&id=2f321f73&scoped=true&"
import script from "./ItsBaseCustomer.vue?vue&type=script&lang=js&"
export * from "./ItsBaseCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f321f73",
  null
  
)

export default component.exports